import React from "react";
import ReactDOM from "react-dom";
import "babel-polyfill";
import { Provider } from "react-redux";
import "./i18n";
import store from "WebsiteApp/logic/store/AppStore";
import registerServiceWorker from "./registerServiceWorker";
import Maintenance from "./modules/auth/pages/Maintanance";

ReactDOM.render(
  <Provider store={store}>
    <div style={{ height: "100vh", width: "100vw" }}>
      <div
        className="inner login-page"
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Maintenance />
      </div>
    </div>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();

export * from "WebsiteApp/logic/crud";
export * from "WebsiteApp/logic/util";
export * from "WebsiteApp/logic/localization";
export * from "WebsiteApp/logic/services";
export * from "WebsiteApp/logic/localization";
export * from "WebsiteApp/components";
export * from "WebsiteApp/elements";



// WEBPACK FOOTER //
// ./src/index.js